import { render } from "./create_projrct.vue?vue&type=template&id=2a30787c&scoped=true"
import script from "./create_projrct.vue?vue&type=script&lang=js"
export * from "./create_projrct.vue?vue&type=script&lang=js"

import "./create_projrct.vue?vue&type=style&index=0&id=2a30787c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a30787c"]])

export default __exports__